/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you are an app developer and requires the theme to re-render the mini-cart, you can trigger your own event. If
 * you are adding a product, you need to trigger the "product:added" event, and make sure that you pass the quantity
 * that was added so the theme can properly update the quantity:
 *
 * document.documentElement.dispatchEvent(new CustomEvent('product:added', {
 *   bubbles: true,
 *   detail: {
 *     quantity: 1
 *   }
 * }));
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */

/* t26 cutting helpers:start */
window.t26CuttingService = (() => {
  const serviceHandle = 'cutting-service';
  const widthMessage = 'Enter a whole cutting width from 2 to 10 cm.';
  const quantityMessage = 'Cutting Service is currently available for orders up to 5 yards. For larger cutting orders, please contact us.';

  const validateSelection = (widthValue, quantityValue) => {
    const width = Number(widthValue);
    const quantity = Number(quantityValue);

    if (!Number.isInteger(width) || width < 2 || width > 10) {
      return { valid: false, message: widthMessage, width, quantity };
    }

    if (!Number.isInteger(quantity) || quantity < 1 || quantity > 5) {
      return { valid: false, message: quantityMessage, width, quantity };
    }

    return { valid: true, message: '', width, quantity };
  };

  const createGroupId = () => window.crypto && window.crypto.randomUUID
    ? window.crypto.randomUUID()
    : `t26-${Date.now()}-${Math.random().toString(16).slice(2)}`;
  const buildAddItems = ({ fabricVariantId, serviceVariantId, quantity, fabricLabel }) => {
    const group = createGroupId();

    return [
      {
        id: Number(fabricVariantId),
        quantity,
        properties: { '✓ Cutting service': 'Included', _t26_cutting_group: group },
      },
      {
        id: Number(serviceVariantId),
        quantity: 1,
        properties: {
          '↳ Applied to': fabricLabel,
          _t26_cutting_group: group,
        },
      },
    ];
  };

  const groupOf = (item) => item && item.properties && item.properties._t26_cutting_group;
  const findPair = (items, group) => ({
    fabric: items.find((item) => groupOf(item) === group && item.handle !== serviceHandle),
    service: items.find((item) => groupOf(item) === group && item.handle === serviceHandle),
  });
  const withoutCuttingProperties = (properties = {}) => Object.fromEntries(
    Object.entries(properties).filter(([key]) => key !== 'Cutting width' && key !== 'Cutting service' && key !== '✓ Cutting service' && key !== '_t26_cutting_group'),
  );
  const addItems = async (fetcher, url, items) => {
    const response = await fetcher(url, {
      body: JSON.stringify({ items }),
      credentials: 'same-origin',
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'X-Requested-With': 'XMLHttpRequest',
      },
    });
    const content = await response.json();

    if (!response.ok) {
      throw new Error(content.description || 'Unable to add Cutting Service to cart.');
    }

    return content;
  };
  const changeLine = async (fetcher, url, id, quantity, properties, sectionRequest = {}) => {
    const response = await fetcher(url, {
      body: JSON.stringify({ id, quantity, ...(properties === undefined ? {} : { properties }), ...sectionRequest }),
      credentials: 'same-origin',
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'X-Requested-With': 'XMLHttpRequest',
      },
    });
    const content = await response.json();

    if (!response.ok) {
      throw new Error(content.description || 'Unable to update the cart.');
    }

    return content;
  };
  const updateLines = async (fetcher, url, updates, sectionRequest = {}) => {
    const response = await fetcher(url, {
      body: JSON.stringify({ updates, ...sectionRequest }),
      credentials: 'same-origin',
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'X-Requested-With': 'XMLHttpRequest',
      },
    });
    const content = await response.json();

    if (!response.ok) {
      throw new Error(content.description || 'Unable to update the cart.');
    }

    return content;
  };

  return {
    addItems,
    buildAddItems,
    changeLine,
    findPair,
    serviceHandle,
    updateLines,
    validateSelection,
    withoutCuttingProperties,
  };
})();
/* t26 cutting helpers:end */

(() => {
  const componentSelector = '[data-t26-cutting-service]';
  const buttonSelector = '[data-action="t26-add-cutting-service"]';
  const componentFor = (target) => {
    const form = target.closest && target.closest('form');

    return (target.closest && target.closest(componentSelector))
      || (form && form.querySelector(componentSelector));
  };

  const elementsFor = (component) => {
    const form = component.closest('form');

    return {
      button: component.querySelector(buttonSelector),
      error: component.querySelector('[data-t26-cutting-error]'),
      form,
      quantity: form && form.querySelector('.quantity-selector--product [name="quantity"], [name="quantity"]'),
      summary: component.querySelector('[data-t26-cutting-summary]'),
      width: component.querySelector('[data-t26-cutting-width]'),
    };
  };

  const updateComponent = (component) => {
    const elements = elementsFor(component);

    if (!elements.button || !elements.width || !elements.quantity) {
      return null;
    }

    const selection = window.t26CuttingService.validateSelection(elements.width.value, elements.quantity.value);
    const marker = selection.valid
      ? component.querySelector(`[data-t26-cutting-variant][data-width="${selection.width}"][data-available="true"]`)
      : null;
    const available = elements.button.dataset.serviceAvailable === 'true'
      && component.dataset.selectedVariantAvailable === 'true'
      && marker;

    elements.button.disabled = !selection.valid || !available;
    elements.error.textContent = selection.valid && !available
      ? 'Cutting Service is temporarily unavailable for this selection.'
      : selection.message;
    elements.error.hidden = !elements.error.textContent;

    if (Number.isFinite(selection.quantity) && Number.isFinite(selection.width)) {
      const unit = selection.quantity === 1 ? 'yd' : 'yds';
      elements.summary.textContent = `All ${selection.quantity} ${unit} of fabric will be cut into ${selection.width} cm-wide rolls.`;
    }

    return { elements, marker, selection };
  };

  const setLoading = (button, loading) => {
    button.disabled = loading;
    button.classList.toggle('is-loading', loading);
    button.setAttribute('aria-busy', loading ? 'true' : 'false');
    button.querySelector('[data-t26-cutting-button-text]').hidden = loading;
    button.querySelector('[data-t26-cutting-button-loading]').hidden = !loading;
  };

  document.addEventListener('input', (event) => {
    const component = componentFor(event.target);

    if (component && event.target.matches('[data-t26-cutting-width], .quantity-selector--product [name="quantity"]')) {
      updateComponent(component);
    }
  });

  document.addEventListener('change', (event) => {
    const component = componentFor(event.target);

    if (component) {
      updateComponent(component);
    }
  });

  document.addEventListener('variant:changed', (event) => {
    const component = event.target.querySelector && event.target.querySelector(componentSelector);

    if (!component || !event.detail || !event.detail.variant) {
      return;
    }

    component.dataset.selectedVariantTitle = event.detail.variant.title;
    component.dataset.selectedVariantAvailable = String(event.detail.variant.available);
    updateComponent(component);
  });

  document.addEventListener('click', async (event) => {
    const button = event.target.closest && event.target.closest(buttonSelector);

    if (!button) {
      return;
    }

    event.preventDefault();
    event.stopPropagation();

    const component = button.closest(componentSelector);
    const state = updateComponent(component);

    if (!state || button.disabled || button.classList.contains('is-loading')) {
      return;
    }

    const variantInput = state.elements.form && state.elements.form.querySelector('[name="id"]');

    if (!variantInput || !variantInput.value || !state.marker) {
      return;
    }

    const items = window.t26CuttingService.buildAddItems({
      fabricVariantId: variantInput.value,
      serviceVariantId: state.marker.dataset.variantId,
      quantity: state.selection.quantity,
      fabricLabel: `${component.dataset.fabricCode} / ${component.dataset.selectedVariantTitle}`,
    });

    setLoading(button, true);
    document.dispatchEvent(new CustomEvent('theme:loading:start'));

    try {
      await window.t26CuttingService.addItems(fetch, `${window.routes.cartAddUrl}.js`, items);
      document.documentElement.dispatchEvent(new CustomEvent('product:added', {
        bubbles: true,
        detail: {
          button,
          variant: { id: Number(variantInput.value) },
          quantity: state.selection.quantity + 1,
          displayQuantity: state.selection.quantity,
          cuttingGroup: items[0].properties._t26_cutting_group,
          productAdded: true,
        },
      }));
    } catch (error) {
      state.elements.error.textContent = error.message;
      state.elements.error.hidden = false;
      document.dispatchEvent(new CustomEvent('theme:loading:end'));
    } finally {
      setLoading(button, false);
      updateComponent(component);
    }
  });

  const initialize = () => document.querySelectorAll(componentSelector).forEach(updateComponent);

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initialize);
  } else {
    initialize();
  }
})();

(() => {
  const groupSelector = '[data-t26-cutting-group]';
  const serviceRemoveSelector = '[data-action="t26-remove-cutting-service"]';
  let updating = false;

  const showError = (message) => {
    const existing = document.querySelector('.t26-cutting-cart-error');

    if (existing) {
      existing.remove();
    }

    const status = document.createElement('div');
    status.className = 'cart__status-message cart__status-message--header t26-cutting-cart-error';
    status.innerHTML = `<div class="alert alert--error"><p class="container"></p></div>`;
    status.querySelector('p').textContent = message;
    (document.querySelector('.header') || document.body).appendChild(status);
    window.setTimeout(() => status.remove(), 5500);
  };

  const fetchCart = async () => {
    const response = await fetch(`${window.routes.cartUrl}.js`, {
      credentials: 'same-origin',
      headers: { 'Cache-Control': 'no-cache', 'X-Requested-With': 'XMLHttpRequest' },
    });
    const content = await response.json();

    if (!response.ok) {
      throw new Error(content.description || 'Unable to read the cart.');
    }

    return content;
  };

  const editPair = async (group, action, quantity, line) => {
    if (action === 'remove-service') {
      const pair = window.t26CuttingService.findPair((await fetchCart()).items, group);

      if (!pair.fabric || !pair.service) {
        throw new Error('The linked Cutting Service could not be found. Refresh the cart and try again.');
      }

      const change = (item, nextQuantity, properties) => window.t26CuttingService.changeLine(
        fetch,
        `${window.routes.cartChangeUrl}.js`,
        item.key,
        nextQuantity,
        properties,
      );
      await change(pair.service, 0);
      const refreshedPair = window.t26CuttingService.findPair((await fetchCart()).items, group);

      if (!refreshedPair.fabric) {
        throw new Error('The linked fabric could not be found. Refresh the cart and try again.');
      }

      await change(refreshedPair.fabric, 0);
      await window.t26CuttingService.addItems(fetch, `${window.routes.cartAddUrl}.js`, [{
        id: refreshedPair.fabric.variant_id,
        quantity: refreshedPair.fabric.quantity,
        properties: window.t26CuttingService.withoutCuttingProperties(refreshedPair.fabric.properties),
      }]);
      return null;
    }

    const fabricKey = line.dataset.t26CuttingKey;
    const serviceKey = line.dataset.t26CuttingServiceKey;
    const sectionId = window.t26CartSections.id();
    const sectionRequest = sectionId ? window.t26CartSections.request(sectionId) : {};

    if (!fabricKey || !serviceKey) {
      throw new Error('The linked Cutting Service could not be found. Refresh the cart and try again.');
    }

    if (quantity === 0) {
      const content = await window.t26CuttingService.updateLines(
        fetch,
        `${window.routes.cartUpdateUrl}.js`,
        { [fabricKey]: 0, [serviceKey]: 0 },
        sectionRequest,
      );
      return window.t26CartSections.html(content, sectionId);
    }

    const content = await window.t26CuttingService.changeLine(
      fetch,
      `${window.routes.cartChangeUrl}.js`,
      fabricKey,
      quantity,
      undefined,
      sectionRequest,
    );
    return window.t26CartSections.html(content, sectionId);
  };

  const handleEdit = async (event) => {
    if (updating) {
      return;
    }

    const serviceRemove = event.target.closest && event.target.closest(serviceRemoveSelector);
    const line = event.target.closest && event.target.closest(groupSelector);

    if (!line) {
      return;
    }

    let action;
    let quantity;

    if (serviceRemove) {
      action = 'remove-service';
    } else if (line.dataset.t26CuttingRole === 'fabric' && event.type === 'click') {
      const control = event.target.closest('[data-action="decrease-quantity"], [data-action="increase-quantity"]');

      if (!control) {
        return;
      }

      action = 'quantity';
      quantity = Number(control.dataset.quantity);
    } else if (line.dataset.t26CuttingRole === 'fabric' && event.type === 'change' && event.target.matches('.quantity-selector__value')) {
      action = 'quantity';
      quantity = Number(event.target.value);
    } else {
      return;
    }

    event.preventDefault();
    event.stopPropagation();

    if (action === 'quantity' && (!Number.isInteger(quantity) || quantity < 0 || quantity > 5)) {
      showError('Cutting Service is currently available for orders up to 5 yards. Remove the service before ordering a larger quantity.');
      document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true, detail: { scrollToTop: false } }));
      return;
    }

    updating = true;
    document.querySelectorAll(`${groupSelector}[data-t26-cutting-group="${line.dataset.t26CuttingGroup}"][data-t26-cutting-role="service"]`).forEach((item) => item.classList.add('t26-is-loading'));
    document.dispatchEvent(new CustomEvent('theme:loading:start'));

    try {
      const sectionHtml = await editPair(line.dataset.t26CuttingGroup, action, quantity, line);
      document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
        bubbles: true,
        detail: { scrollToTop: false, t26SectionHtml: sectionHtml },
      }));
    } catch (error) {
      showError(error.message);
      document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true, detail: { scrollToTop: false } }));
    } finally {
      updating = false;
    }
  };

  document.addEventListener('click', handleEdit, true);
  document.addEventListener('change', handleEdit, true);
})();

(() => {
  const t26VariantRadioSelector = 'variant-picker input.product-form__single-selector[type="radio"][data-option-position]';
  const t26LargePreviewToggleSelector = '[data-t26-large-preview-toggle]';
  const t26LargePreviewModalSelector = '[data-t26-large-preview-modal]';
  const t26LargePreviewCloseSelector = '[data-t26-large-preview-close]';
  const t26LargePreviewImageSelector = '[data-t26-large-preview-image]';
  const t26LargePreviewQuantityInputSelector = '[data-t26-large-preview-quantity-input]';
  const t26LargePreviewAddToCartSelector = '[data-t26-large-preview-add-to-cart]';
  const t26LargePreviewDesktopQuery = window.matchMedia('(min-width: 1000px)');
  const t26LargePreviewImageSizes = '(max-width: 999px) calc(100vw - 32px), 1px';
  const t26LargePreviewImageWidths = [360, 540, 720, 900, 1080];
  const t26LargePreviewState = new Map();
  const t26LargePreviewPendingOpen = new Set();
  const t26LargePreviewPendingSource = new Map();
  let t26LargePreviewPendingCartModal = null;

  const t26IsLargePreviewMobileViewport = () => !t26LargePreviewDesktopQuery.matches;

  const t26GetVariantRadio = (target) => {
    if (target.matches && target.matches(t26VariantRadioSelector)) {
      return target;
    }

    const label = target.closest && target.closest('label[for]');

    if (!label) {
      return null;
    }

    const input = document.getElementById(label.htmlFor);

    return input && input.matches(t26VariantRadioSelector) ? input : null;
  };

  const t26GetLargePreviewKey = (element) => {
    const variantPicker = element.closest && element.closest('variant-picker');

    if (variantPicker && variantPicker.getAttribute('form-id')) {
      return variantPicker.getAttribute('form-id');
    }

    const form = element.closest && element.closest('form');

    if (form && form.id) {
      return form.id;
    }

    const section = element.closest && element.closest('[data-section-id]');

    return section ? section.getAttribute('data-section-id') : 'default';
  };

  const t26UpdateLargePreviewRootState = () => {
    const hasEnabledPreview = Array.from(t26LargePreviewState.values()).some(Boolean);

    document.documentElement.classList.toggle('t26-large-preview-enabled', hasEnabledPreview);
  };

  const t26SetLargePreviewToggleState = (toggle, enabled) => {
    const toggleLabel = toggle.closest('.t26-large-preview-toggle');
    const willChange = toggle.checked !== enabled;

    if (toggleLabel && willChange) {
      toggleLabel.classList.add('t26-large-preview-toggle--restore');
    }

    toggle.checked = enabled;

    if (toggleLabel && willChange) {
      window.requestAnimationFrame(() => {
        toggleLabel.classList.remove('t26-large-preview-toggle--restore');
      });
    }
  };

  const t26SyncLargePreviewToggle = (toggle) => {
    const key = t26GetLargePreviewKey(toggle);
    const enabled = toggle.checked;

    t26LargePreviewState.set(key, enabled);
    t26UpdateLargePreviewRootState();
    t26SetLargePreviewToggleState(toggle, enabled);

    if (!enabled) {
      t26LargePreviewPendingOpen.delete(key);
      t26LargePreviewPendingSource.delete(key);
      t26CloseLargePreviewModal(toggle.closest('[data-section-type]') || document);
    }
  };

  const t26RestoreLargePreviewStates = () => {
    const shouldDefaultToEnabled = t26IsLargePreviewMobileViewport();

    document.querySelectorAll(t26LargePreviewToggleSelector).forEach((toggle) => {
      const key = t26GetLargePreviewKey(toggle);

      if (shouldDefaultToEnabled && !t26LargePreviewState.has(key)) {
        t26LargePreviewState.set(key, true);
      }

      const enabled = t26LargePreviewState.get(key) === true;

      t26SetLargePreviewToggleState(toggle, enabled);
    });

    t26UpdateLargePreviewRootState();
  };

  const t26IsLargePreviewEnabled = (element) => {
    if (!t26IsLargePreviewMobileViewport()) {
      return false;
    }

    const option = element.closest && element.closest('.product-form__option');
    const toggle = option && option.querySelector(t26LargePreviewToggleSelector);

    if (!toggle) {
      return false;
    }

    return toggle.checked || t26LargePreviewState.get(t26GetLargePreviewKey(toggle)) === true;
  };

  const t26GetProductForm = (element) => {
    const variantPicker = element.closest && element.closest('variant-picker');
    const formId = variantPicker && variantPicker.getAttribute('form-id');

    if (formId && document.forms[formId]) {
      return document.forms[formId];
    }

    return element.closest && element.closest('form');
  };

  const t26GetLargePreviewModal = (element) => {
    const option = element.closest && element.closest('.product-form__option');

    return option && option.querySelector(t26LargePreviewModalSelector);
  };

  const t26GetSourceQuantityInput = (modal) => {
    const form = t26GetProductForm(modal);

    return form && form.querySelector('.quantity-selector--product [name="quantity"]');
  };

  const t26GetModalQuantityInput = (modal) => modal && modal.querySelector(t26LargePreviewQuantityInputSelector);

  const t26GetLargePreviewImage = (modal) => modal && modal.querySelector(t26LargePreviewImageSelector);

  const t26GetVariantPreviewLabel = (input) => {
    if (!input) {
      return null;
    }

    const labels = input.labels ? Array.from(input.labels) : [];
    const previewLabel = labels.find((label) => label.matches('.variant-swatch__item'));

    return previewLabel || labels[0] || null;
  };

  const t26SetImageWidth = (url, width) => {
    if (!url) {
      return '';
    }

    try {
      const imageUrl = new URL(url, window.location.href);
      imageUrl.searchParams.set('width', width);

      return imageUrl.toString();
    } catch (error) {
      return url;
    }
  };

  const t26BuildLargePreviewSrcset = (url, widths) => {
    if (!url) {
      return '';
    }

    return widths.map((width) => `${t26SetImageWidth(url, width)} ${width}w`).join(', ');
  };

  const t26PrioritizeLargePreviewImage = (image) => {
    if (!image) {
      return;
    }

    image.setAttribute('loading', 'eager');
    image.setAttribute('decoding', 'async');
    image.setAttribute('fetchpriority', 'high');
  };

  const t26SetLargePreviewPendingVariant = (modal, isPending) => {
    if (!modal) {
      return;
    }

    modal.toggleAttribute('data-t26-large-preview-pending-variant', isPending);

    const addToCartButton = modal.querySelector(t26LargePreviewAddToCartSelector);

    if (!addToCartButton) {
      return;
    }

    addToCartButton.disabled = isPending;
    addToCartButton.setAttribute('aria-disabled', isPending ? 'true' : 'false');
  };

  const t26SetLargePreviewImageSource = (image, options) => {
    if (!image || !options || !options.src) {
      return;
    }

    const imageFrame = image.parentElement;

    if (imageFrame) {
      imageFrame.querySelectorAll('.t26-large-preview-modal__image--fade-layer').forEach((fadeLayer) => {
        fadeLayer.remove();
      });
    }

    t26PrioritizeLargePreviewImage(image);

    if (Object.prototype.hasOwnProperty.call(options, 'alt')) {
      image.alt = options.alt || '';
    }

    if (options.sizes) {
      image.sizes = options.sizes;
    } else {
      image.removeAttribute('sizes');
    }

    if (options.srcset) {
      image.srcset = options.srcset;
    } else {
      image.removeAttribute('srcset');
    }

    image.src = options.src;
  };

  const t26FadeLargePreviewImageSource = (image, options, loadToken) => {
    if (!image || !options || !options.src) {
      return;
    }

    const imageFrame = image.parentElement;

    if (!imageFrame) {
      t26SetLargePreviewImageSource(image, options);

      return;
    }

    imageFrame.querySelectorAll('.t26-large-preview-modal__image--fade-layer').forEach((fadeLayer) => {
      fadeLayer.remove();
    });

    const fadeImage = new Image();
    let didFinish = false;

    fadeImage.className = `${image.className} t26-large-preview-modal__image--fade-layer`;
    fadeImage.alt = '';
    fadeImage.setAttribute('aria-hidden', 'true');
    fadeImage.decoding = 'async';

    if (options.sizes) {
      fadeImage.sizes = options.sizes;
    }

    if (options.srcset) {
      fadeImage.srcset = options.srcset;
    }

    fadeImage.src = options.src;

    const finishFade = () => {
      if (didFinish) {
        return;
      }

      didFinish = true;

      if (image.isConnected && (!loadToken || image.dataset.t26LargePreviewLoadToken === loadToken)) {
        t26SetLargePreviewImageSource(image, options);
      }

      fadeImage.remove();
    };

    fadeImage.addEventListener('transitionend', finishFade, { once: true });
    imageFrame.appendChild(fadeImage);

    window.requestAnimationFrame(() => {
      if (!fadeImage.isConnected || !image.isConnected || (loadToken && image.dataset.t26LargePreviewLoadToken !== loadToken)) {
        fadeImage.remove();

        return;
      }

      fadeImage.classList.add('is-visible');
      window.setTimeout(finishFade, 280);
    });
  };

  const t26GetLargePreviewSourceFromVariant = (input) => {
    const label = t26GetVariantPreviewLabel(input);
    const sourceImage = label && label.querySelector('img');
    const thumbnailSrc = sourceImage && (sourceImage.currentSrc || sourceImage.src);

    if (!label || !sourceImage || !thumbnailSrc) {
      return null;
    }

    const sourceAspectRatio = sourceImage.closest('.aspect-ratio');

    return {
      alt: sourceImage.alt,
      highResSrc: sourceImage.dataset.t26LargePreviewSrc || thumbnailSrc,
      optionValue: label.getAttribute('title') || sourceImage.alt || '',
      paddingBottom: sourceAspectRatio && sourceAspectRatio.style.paddingBottom ? sourceAspectRatio.style.paddingBottom : '',
      sizes: sourceImage.dataset.t26LargePreviewSizes || t26LargePreviewImageSizes,
      thumbnailSrc,
      widths: (sourceImage.dataset.t26LargePreviewWidths || '')
        .split(',')
        .map((width) => parseInt(width, 10))
        .filter(Boolean)
    };
  };

  const t26LoadLargePreviewHighResImage = (modal, previewSource) => {
    const modalImage = t26GetLargePreviewImage(modal);
    const baseSrc = previewSource && (previewSource.highResSrc || previewSource.thumbnailSrc);

    if (!modalImage || !baseSrc) {
      return;
    }

    const srcsetWidths = previewSource.widths.length > 0 ? previewSource.widths : t26LargePreviewImageWidths;
    const sizes = previewSource.sizes || t26LargePreviewImageSizes;
    const srcset = t26BuildLargePreviewSrcset(baseSrc, srcsetWidths);
    const highResSrc = t26SetImageWidth(baseSrc, srcsetWidths[srcsetWidths.length - 1]);
    const loadToken = `${Date.now()}-${Math.random()}`;
    const loader = new Image();

    modalImage.dataset.t26LargePreviewLoadToken = loadToken;
    loader.decoding = 'async';
    loader.sizes = sizes;
    loader.srcset = srcset;
    loader.src = highResSrc;

    const applyHighRes = () => {
      if (!modalImage.isConnected || modalImage.dataset.t26LargePreviewLoadToken !== loadToken) {
        return;
      }

      t26FadeLargePreviewImageSource(modalImage, {
        alt: previewSource.alt,
        sizes,
        src: loader.currentSrc || highResSrc,
        srcset
      }, loadToken);
    };

    const swapToHighRes = () => {
      if (typeof loader.decode === 'function') {
        loader.decode().catch(() => {}).then(applyHighRes);

        return;
      }

      applyHighRes();
    };

    if (loader.complete && loader.naturalWidth > 0) {
      swapToHighRes();
    } else {
      loader.addEventListener('load', swapToHighRes, { once: true });
    }
  };

  const t26ApplyLargePreviewSource = (modal, previewSource, isPendingVariant) => {
    const modalImage = t26GetLargePreviewImage(modal);

    if (!modal || !previewSource || !modalImage || !previewSource.thumbnailSrc) {
      return false;
    }

    const modalAspectRatio = modalImage.closest('.aspect-ratio');
    const optionValueElement = modal.querySelector('.t26-large-preview-modal__option-value');

    if (modalAspectRatio && previewSource.paddingBottom) {
      modalAspectRatio.style.paddingBottom = previewSource.paddingBottom;
    }

    if (optionValueElement && previewSource.optionValue) {
      optionValueElement.textContent = previewSource.optionValue;
    }

    t26SetLargePreviewImageSource(modalImage, {
      alt: previewSource.alt,
      src: previewSource.thumbnailSrc
    });
    t26OpenLargePreviewModal(modal);
    t26SetLargePreviewPendingVariant(modal, isPendingVariant);
    t26LoadLargePreviewHighResImage(modal, previewSource);

    return true;
  };

  const t26PrimeLargePreviewModalFromVariant = (input, isPendingVariant) => {
    const modal = t26GetLargePreviewModal(input);
    const previewSource = t26GetLargePreviewSourceFromVariant(input);

    if (!t26ApplyLargePreviewSource(modal, previewSource, isPendingVariant)) {
      return null;
    }

    return previewSource;
  };

  const t26SyncModalQuantityFromForm = (modal) => {
    const sourceQuantityInput = t26GetSourceQuantityInput(modal);
    const modalQuantityInput = t26GetModalQuantityInput(modal);

    if (!sourceQuantityInput || !modalQuantityInput) {
      return;
    }

    modalQuantityInput.value = sourceQuantityInput.value;
    modalQuantityInput.min = sourceQuantityInput.min;
    modalQuantityInput.step = sourceQuantityInput.step;

    if (sourceQuantityInput.max) {
      modalQuantityInput.max = sourceQuantityInput.max;
    } else {
      modalQuantityInput.removeAttribute('max');
    }
  };

  const t26SetSourceQuantityFromModal = (modal) => {
    const sourceQuantityInput = t26GetSourceQuantityInput(modal);
    const modalQuantityInput = t26GetModalQuantityInput(modal);

    if (!sourceQuantityInput || !modalQuantityInput) {
      return;
    }

    sourceQuantityInput.value = modalQuantityInput.value;
    sourceQuantityInput.dispatchEvent(new Event('input', { bubbles: true }));
    sourceQuantityInput.dispatchEvent(new Event('change', { bubbles: true }));
  };

  const t26SetModalQuantityValue = (modal, nextValue) => {
    const modalQuantityInput = t26GetModalQuantityInput(modal);

    if (!modalQuantityInput) {
      return;
    }

    const min = parseInt(modalQuantityInput.min, 10) || 1;
    const max = modalQuantityInput.max ? parseInt(modalQuantityInput.max, 10) : null;
    let value = Math.max(nextValue, min);

    if (max !== null) {
      value = Math.min(value, max);
    }

    modalQuantityInput.value = value;
    t26SetSourceQuantityFromModal(modal);
  };

  const t26OpenLargePreviewModal = (modal) => {
    if (!modal) {
      return;
    }

    const toggle = modal.closest('.product-form__option')?.querySelector(t26LargePreviewToggleSelector);

    if (!t26IsLargePreviewMobileViewport()) {
      modal.hidden = true;
      modal.setAttribute('aria-hidden', 'true');

      if (toggle) {
        toggle.setAttribute('aria-expanded', 'false');
      }

      document.documentElement.classList.remove('t26-large-preview-modal-open');

      return;
    }

    const enabled = toggle && (toggle.checked || t26LargePreviewState.get(t26GetLargePreviewKey(toggle)) === true);

    if (!toggle || !enabled) {
      return;
    }

    t26SetLargePreviewToggleState(toggle, true);
    t26SyncModalQuantityFromForm(modal);
    t26PrioritizeLargePreviewImage(t26GetLargePreviewImage(modal));
    modal.hidden = false;
    modal.setAttribute('aria-hidden', 'false');
    toggle.setAttribute('aria-expanded', 'true');
    document.documentElement.classList.add('t26-large-preview-modal-open');

    const closeButton = modal.querySelector(t26LargePreviewCloseSelector);

    if (closeButton) {
      closeButton.focus();
    }
  };

  const t26SyncLargePreviewModalLock = () => {
    if (!t26IsLargePreviewMobileViewport()) {
      document.documentElement.classList.remove('t26-large-preview-modal-open');

      return;
    }

    if (!document.querySelector(`${t26LargePreviewModalSelector}:not([hidden])`)) {
      document.documentElement.classList.remove('t26-large-preview-modal-open');
    }
  };

  const t26CloseLargePreviewModal = (scope) => {
    const root = scope && scope.querySelectorAll ? scope : document;

    root.querySelectorAll(`${t26LargePreviewModalSelector}:not([hidden])`).forEach((modal) => {
      const toggle = modal.closest('.product-form__option')?.querySelector(t26LargePreviewToggleSelector);

      modal.hidden = true;
      modal.setAttribute('aria-hidden', 'true');

      if (toggle) {
        toggle.setAttribute('aria-expanded', 'false');
      }
    });

    t26SyncLargePreviewModalLock();
  };

  const t26SetLargePreviewAddToCartLoading = (button, isLoading) => {
    if (!button) {
      return;
    }

    button.classList.toggle('is-loading', isLoading);
    button.setAttribute('aria-busy', isLoading ? 'true' : 'false');
  };

  const t26ClearLargePreviewAddToCartLoading = (modal) => {
    const root = modal || document;

    root.querySelectorAll(`${t26LargePreviewAddToCartSelector}.is-loading`).forEach((button) => {
      t26SetLargePreviewAddToCartLoading(button, false);
    });
  };

  const t26OpenPendingLargePreviewModal = (key, isPendingVariant = true) => {
    if (!t26LargePreviewPendingOpen.has(key)) {
      return false;
    }

    if (!t26IsLargePreviewMobileViewport()) {
      t26LargePreviewPendingOpen.delete(key);
      t26SyncLargePreviewModalLock();

      return false;
    }

    const toggle = Array.from(document.querySelectorAll(t26LargePreviewToggleSelector)).find((candidate) => t26GetLargePreviewKey(candidate) === key);
    const modal = toggle && t26GetLargePreviewModal(toggle);
    const previewSource = t26LargePreviewPendingSource.get(key);

    if (modal) {
      if (previewSource) {
        t26ApplyLargePreviewSource(modal, previewSource, isPendingVariant);
      } else {
        t26OpenLargePreviewModal(modal);
        t26SetLargePreviewPendingVariant(modal, isPendingVariant);
      }

      return true;
    }

    return false;
  };

  const t26QueueLargePreviewModalOpen = (key) => {
    t26LargePreviewPendingOpen.add(key);

    [350, 700, 1100].forEach((delay) => {
      window.setTimeout(() => {
        t26RestoreLargePreviewStates();
        t26OpenPendingLargePreviewModal(key);
        t26SyncLargePreviewModalLock();
      }, delay);
    });

    window.setTimeout(() => {
      t26LargePreviewPendingOpen.delete(key);
      t26LargePreviewPendingSource.delete(key);
      t26SyncLargePreviewModalLock();
    }, 1400);
  };

  const t26MarkCheckedState = (event) => {
    const input = t26GetVariantRadio(event.target);

    if (input) {
      input.dataset.t26WasChecked = input.checked ? 'true' : 'false';
    }
  };

  const t26ShowSelectedVariantMedia = (event) => {
    const input = t26GetVariantRadio(event.target);

    if (input && t26IsLargePreviewEnabled(input)) {
      const key = t26GetLargePreviewKey(input);
      const wasChecked = input.dataset.t26WasChecked === 'true';

      delete input.dataset.t26WasChecked;
      const previewSource = t26PrimeLargePreviewModalFromVariant(input, !wasChecked);

      if (previewSource) {
        t26LargePreviewPendingSource.set(key, previewSource);
      }

      t26QueueLargePreviewModalOpen(key);

      return;
    }

    if (!input || input.dataset.t26WasChecked !== 'true') {
      return;
    }

    delete input.dataset.t26WasChecked;

    const variantPicker = input.closest('variant-picker');
    const variantScript = variantPicker && variantPicker.querySelector('script[data-variant]');
    const variantJson = variantScript && variantScript.textContent;

    if (!variantJson) {
      return;
    }

    let variant;

    try {
      variant = JSON.parse(variantJson);
    } catch (error) {
      return;
    }

    const mediaId = variant && variant.featured_media && variant.featured_media.id;

    if (!mediaId) {
      return;
    }

    const section = variantPicker.closest('[data-section-type="product"], [data-section-type="product-quick-view"]') || document;
    const thumbnail = section.querySelector(`.product-gallery__thumbnail[data-media-id="${mediaId}"]`);

    if (thumbnail && !thumbnail.classList.contains('is-nav-selected')) {
      thumbnail.dispatchEvent(new MouseEvent('click', { bubbles: true, cancelable: true, view: window }));
    }
  };

  const t26HandleLargePreviewToggleChange = (event) => {
    const toggle = event.target.closest && event.target.closest(t26LargePreviewToggleSelector);

    if (!toggle) {
      return;
    }

    t26SyncLargePreviewToggle(toggle);
  };

  const t26ScheduleLargePreviewRestore = () => {
    const restore = () => {
      t26RestoreLargePreviewStates();
      Array.from(t26LargePreviewPendingOpen).forEach((key) => {
        if (t26OpenPendingLargePreviewModal(key, false)) {
          t26LargePreviewPendingOpen.delete(key);
          t26LargePreviewPendingSource.delete(key);
        }
      });
      t26SyncLargePreviewModalLock();
    };

    window.requestAnimationFrame(restore);
    window.setTimeout(restore, 80);
  };

  const t26HandleLargePreviewClose = (event) => {
    if (!event.target.closest || !event.target.closest(t26LargePreviewCloseSelector)) {
      return;
    }

    const modal = event.target.closest(t26LargePreviewModalSelector);
    const toggle = modal && modal.closest('.product-form__option')?.querySelector(t26LargePreviewToggleSelector);

    if (toggle) {
      const key = t26GetLargePreviewKey(toggle);

      t26LargePreviewPendingOpen.delete(key);
      t26LargePreviewPendingSource.delete(key);
    }

    t26CloseLargePreviewModal(document);
  };

  const t26HandleLargePreviewQuantityClick = (event) => {
    const button = event.target.closest && event.target.closest('[data-t26-large-preview-quantity]');

    if (!button) {
      return;
    }

    const modal = button.closest(t26LargePreviewModalSelector);
    const modalQuantityInput = t26GetModalQuantityInput(modal);

    if (!modalQuantityInput) {
      return;
    }

    const step = parseInt(modalQuantityInput.step, 10) || 1;
    const currentValue = parseInt(modalQuantityInput.value, 10) || parseInt(modalQuantityInput.min, 10) || 1;
    const direction = button.dataset.t26LargePreviewQuantity === 'increase' ? 1 : -1;

    t26SetModalQuantityValue(modal, currentValue + step * direction);
  };

  const t26HandleLargePreviewQuantityChange = (event) => {
    const modalQuantityInput = event.target.closest && event.target.closest(t26LargePreviewQuantityInputSelector);

    if (!modalQuantityInput) {
      return;
    }

    const modal = modalQuantityInput.closest(t26LargePreviewModalSelector);
    const value = parseInt(modalQuantityInput.value, 10) || parseInt(modalQuantityInput.min, 10) || 1;

    t26SetModalQuantityValue(modal, value);
  };

  const t26HandleLargePreviewAddToCart = (event) => {
    const button = event.target.closest && event.target.closest(t26LargePreviewAddToCartSelector);

    if (!button) {
      return;
    }

    event.preventDefault();

    if (button.classList.contains('is-loading')) {
      return;
    }

    const modal = button.closest(t26LargePreviewModalSelector);

    if (modal && modal.hasAttribute('data-t26-large-preview-pending-variant')) {
      return;
    }

    const form = t26GetProductForm(modal);
    const addToCartButton = form && form.querySelector('[data-t26-loading-button="add-to-cart"], .product-form__add-button:not(.button--disabled):not([disabled])');

    if (!addToCartButton) {
      return;
    }

    t26SetSourceQuantityFromModal(modal);
    t26LargePreviewPendingCartModal = modal;
    t26SetLargePreviewAddToCartLoading(button, true);
    addToCartButton.click();
  };

  const t26HandleLargePreviewEscape = (event) => {
    if (event.key === 'Escape') {
      t26CloseLargePreviewModal(document);
    }
  };

  const t26HandleLargePreviewProductAdded = (event) => {
    if (!t26LargePreviewPendingCartModal) {
      return;
    }

    const modal = t26LargePreviewPendingCartModal;
    const productAdded = !event.detail || event.detail.productAdded !== false;

    if (!productAdded) {
      t26ClearLargePreviewAddToCartLoading(modal);
      t26LargePreviewPendingCartModal = null;
      return;
    }

    window.setTimeout(() => {
      t26ClearLargePreviewAddToCartLoading(modal);
      t26CloseLargePreviewModal(document);
      t26LargePreviewPendingCartModal = null;
    }, 450);
  };

  const t26HandleLargePreviewLoadingEnd = () => {
    if (!t26LargePreviewPendingCartModal) {
      return;
    }

    t26ClearLargePreviewAddToCartLoading(t26LargePreviewPendingCartModal);
    t26LargePreviewPendingCartModal = null;
  };

  const t26HandleLargePreviewViewportChange = (event) => {
    if (!event.matches) {
      t26RestoreLargePreviewStates();

      return;
    }

    t26LargePreviewPendingOpen.clear();
    t26LargePreviewPendingSource.clear();
    t26ClearLargePreviewAddToCartLoading(t26LargePreviewPendingCartModal || document);
    t26LargePreviewPendingCartModal = null;
    t26CloseLargePreviewModal(document);
  };

  const t26AddLargePreviewMediaQueryListener = (mediaQuery, handler) => {
    if (mediaQuery.addEventListener) {
      mediaQuery.addEventListener('change', handler);
    } else if (mediaQuery.addListener) {
      mediaQuery.addListener(handler);
    }
  };

  document.addEventListener('pointerdown', t26MarkCheckedState);
  document.addEventListener('click', t26ShowSelectedVariantMedia);
  document.addEventListener('click', t26HandleLargePreviewClose);
  document.addEventListener('click', t26HandleLargePreviewQuantityClick);
  document.addEventListener('click', t26HandleLargePreviewAddToCart);
  document.addEventListener('change', t26HandleLargePreviewQuantityChange);
  document.addEventListener('change', t26HandleLargePreviewToggleChange);
  document.addEventListener('keydown', t26HandleLargePreviewEscape);
  document.addEventListener('product:added', t26HandleLargePreviewProductAdded);
  document.addEventListener('theme:loading:end', t26HandleLargePreviewLoadingEnd);
  document.addEventListener('product:rerender', t26ScheduleLargePreviewRestore, true);
  t26AddLargePreviewMediaQueryListener(t26LargePreviewDesktopQuery, t26HandleLargePreviewViewportChange);
  t26HandleLargePreviewViewportChange(t26LargePreviewDesktopQuery);
  t26RestoreLargePreviewStates();
})();

(() => {
  const t26AutoplaySelector = '[data-t26-autoplay-media]';
  const t26AutoplayAttemptLimit = 12;
  const t26AutoplayAttemptDelay = 500;

  const t26AppendVideoParams = (iframe, params) => {
    const rawSrc = iframe.getAttribute('src') || iframe.getAttribute('data-src');

    if (!rawSrc) {
      return;
    }

    const url = new URL(rawSrc, window.location.href);
    let changed = false;

    Object.keys(params).forEach((key) => {
      if (url.searchParams.get(key) !== params[key]) {
        url.searchParams.set(key, params[key]);
        changed = true;
      }
    });

    iframe.setAttribute('allow', [iframe.getAttribute('allow'), 'autoplay'].filter(Boolean).join('; '));

    if (changed) {
      iframe.setAttribute('src', url.toString());
    }
  };

  const t26PostIframeCommand = (iframe, payload) => {
    if (!iframe || !iframe.contentWindow) {
      return;
    }

    iframe.contentWindow.postMessage(JSON.stringify(payload), '*');
  };

  const t26PlayAutoplayMedia = (media) => {
    if (!media || media.dataset.t26AutoplayStarted === 'true') {
      return;
    }

    const mediaType = media.getAttribute('data-media-type');

    if (mediaType === 'video') {
      const video = media.querySelector('video');

      if (!video) {
        return;
      }

      media.dataset.t26AutoplayStarted = 'true';
      video.muted = true;
      video.defaultMuted = true;
      video.autoplay = true;
      video.playsInline = true;
      video.setAttribute('muted', '');
      video.setAttribute('autoplay', '');
      video.setAttribute('playsinline', '');

      const playPromise = video.play && video.play();

      if (playPromise && playPromise.catch) {
        playPromise.catch(() => {});
      }

      return;
    }

    if (mediaType === 'external_video') {
      const iframe = media.querySelector('iframe');
      const host = media.getAttribute('data-media-host');

      if (!iframe) {
        return;
      }

      media.dataset.t26AutoplayStarted = 'true';

      if (host === 'youtube') {
        t26AppendVideoParams(iframe, {
          autoplay: '1',
          mute: '1',
          playsinline: '1',
          enablejsapi: '1'
        });
        t26PostIframeCommand(iframe, { event: 'command', func: 'mute', args: [] });
        t26PostIframeCommand(iframe, { event: 'command', func: 'playVideo', args: [] });
      } else if (host === 'vimeo') {
        t26AppendVideoParams(iframe, {
          autoplay: '1',
          muted: '1',
          playsinline: '1'
        });
        t26PostIframeCommand(iframe, { method: 'setVolume', value: 0 });
        t26PostIframeCommand(iframe, { method: 'play' });
      }
    }
  };

  const t26InitProductMediaAutoplay = () => {
    const media = document.querySelector(`${t26AutoplaySelector}.is-selected`);

    if (!media) {
      return;
    }

    let attempts = 0;

    const attemptPlay = () => {
      if (!media.isConnected || media.dataset.t26AutoplayStarted === 'true') {
        return;
      }

      t26PlayAutoplayMedia(media);
      attempts += 1;

      if (attempts < t26AutoplayAttemptLimit && media.dataset.t26AutoplayStarted !== 'true') {
        window.setTimeout(attemptPlay, t26AutoplayAttemptDelay);
      }
    };

    attemptPlay();
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', t26InitProductMediaAutoplay);
  } else {
    t26InitProductMediaAutoplay();
  }

  window.addEventListener('load', t26InitProductMediaAutoplay);
  document.addEventListener('product:rerendered', t26InitProductMediaAutoplay);
})();

(() => {
  const t26MobileSearchQuery = '(max-width: 640px)';
  const t26DesktopSearchQuery = '(min-width: 1000px)';
  const t26DesktopSearchPanelMaxWidth = 640;
  const t26DesktopSearchPanelViewportGap = 20;
  const t26SearchInputSelector = '.t26-header-search .search-bar__input';
  const t26PredictiveSelector = '.saf-predictive, .saf-predictive__panel';
  const t26FocusClass = 't26-search-focus-mode';
  const t26HasResultsClass = 't26-search-focus-mode--has-results';
  const t26Media = window.matchMedia(t26MobileSearchQuery);
  const t26DesktopMedia = window.matchMedia(t26DesktopSearchQuery);
  let t26SyncFrame = null;
  let t26ScrollLock = null;

  const t26IsMobile = () => t26Media.matches;

  const t26HasPredictivePanel = () => {
    return Array.from(document.querySelectorAll('.saf-predictive__panel')).some((panel) => {
      const rect = panel.getBoundingClientRect();
      const style = window.getComputedStyle(panel);

      return style.display !== 'none' && style.visibility !== 'hidden' && rect.width > 0 && rect.height > 0;
    });
  };

  const t26GetSearchInput = () => document.querySelector(t26SearchInputSelector);

  const t26GetPredictiveRoot = () => document.querySelector('.saf-predictive');

  const t26ResetDesktopPredictivePanel = () => {
    const root = t26GetPredictiveRoot();

    if (!root) {
      return;
    }

    root.style.removeProperty('--t26-desktop-search-panel-left');
    root.style.removeProperty('--t26-desktop-search-panel-right');
    root.style.removeProperty('--t26-desktop-search-panel-width');
  };

  const t26PositionDesktopPredictivePanel = (hasPanel) => {
    const input = t26GetSearchInput();
    const root = t26GetPredictiveRoot();

    if (!t26DesktopMedia.matches || !input || !root || !hasPanel) {
      t26ResetDesktopPredictivePanel();
      return;
    }

    const viewportWidth = window.innerWidth || document.documentElement.clientWidth;
    const panelWidth = Math.min(
      t26DesktopSearchPanelMaxWidth,
      viewportWidth - (t26DesktopSearchPanelViewportGap * 2)
    );
    const inputRect = input.getBoundingClientRect();
    const maxLeft = viewportWidth - panelWidth - t26DesktopSearchPanelViewportGap;
    const left = Math.max(
      t26DesktopSearchPanelViewportGap,
      Math.min(inputRect.left, maxLeft)
    );

    root.style.setProperty('--t26-desktop-search-panel-left', `${left}px`);
    root.style.setProperty('--t26-desktop-search-panel-right', 'auto');
    root.style.setProperty('--t26-desktop-search-panel-width', `${panelWidth}px`);
  };

  const t26LockPageScroll = () => {
    if (t26ScrollLock) {
      return;
    }

    t26ScrollLock = {
      left: document.body.style.left,
      position: document.body.style.position,
      right: document.body.style.right,
      scrollY: window.scrollY || window.pageYOffset || 0,
      top: document.body.style.top,
      width: document.body.style.width
    };

    document.body.style.left = '0';
    document.body.style.position = 'fixed';
    document.body.style.right = '0';
    document.body.style.top = `-${t26ScrollLock.scrollY}px`;
    document.body.style.width = '100%';
  };

  const t26UnlockPageScroll = () => {
    if (!t26ScrollLock) {
      return;
    }

    const scrollY = t26ScrollLock.scrollY;

    document.body.style.left = t26ScrollLock.left;
    document.body.style.position = t26ScrollLock.position;
    document.body.style.right = t26ScrollLock.right;
    document.body.style.top = t26ScrollLock.top;
    document.body.style.width = t26ScrollLock.width;

    t26ScrollLock = null;
    window.scrollTo(0, scrollY);
  };

  const t26CloseSearchFocusMode = () => {
    document.documentElement.classList.remove(t26FocusClass, t26HasResultsClass);
    t26UnlockPageScroll();
  };

  const t26SyncSearchFocusMode = () => {
    const input = t26GetSearchInput();
    const hasActiveInput = input && document.activeElement === input;
    const hasPanel = t26HasPredictivePanel();
    const shouldOpen = t26IsMobile() && (hasActiveInput || hasPanel);

    t26PositionDesktopPredictivePanel(hasPanel);

    if (shouldOpen) {
      t26LockPageScroll();
    } else {
      t26UnlockPageScroll();
    }

    document.documentElement.classList.toggle(t26FocusClass, shouldOpen);
    document.documentElement.classList.toggle(t26HasResultsClass, shouldOpen && hasPanel);
  };

  const t26ScheduleSearchFocusMode = () => {
    if (t26SyncFrame) {
      return;
    }

    t26SyncFrame = window.requestAnimationFrame(() => {
      t26SyncFrame = null;
      t26SyncSearchFocusMode();
    });
  };

  const t26HandleSearchEvent = (event) => {
    if (event.target && event.target.closest && event.target.closest(t26SearchInputSelector)) {
      t26ScheduleSearchFocusMode();
    }
  };

  const t26HandleDocumentClick = (event) => {
    if (!document.documentElement.classList.contains(t26FocusClass)) {
      return;
    }

    const target = event.target;

    if (
      target.closest &&
      (target.closest('.t26-header-search') || target.closest(t26PredictiveSelector))
    ) {
      t26ScheduleSearchFocusMode();
      return;
    }

    t26CloseSearchFocusMode();
  };

  const t26HandleKeydown = (event) => {
    if (event.key === 'Escape') {
      t26CloseSearchFocusMode();
    }
  };

  document.addEventListener('focusin', t26HandleSearchEvent);
  document.addEventListener('input', t26HandleSearchEvent);
  document.addEventListener('click', t26HandleDocumentClick);
  document.addEventListener('keydown', t26HandleKeydown);
  document.addEventListener('saf:predictive-close', t26CloseSearchFocusMode);

  if (t26Media.addEventListener) {
    t26Media.addEventListener('change', t26SyncSearchFocusMode);
    t26DesktopMedia.addEventListener('change', t26SyncSearchFocusMode);
  } else if (t26Media.addListener) {
    t26Media.addListener(t26SyncSearchFocusMode);
    t26DesktopMedia.addListener(t26SyncSearchFocusMode);
  }

  if (typeof MutationObserver !== 'undefined') {
    const observer = new MutationObserver(() => {
      t26ScheduleSearchFocusMode();
    });

    if (document.body) {
      observer.observe(document.body, {
        childList: true,
        subtree: true,
        attributes: true,
        attributeFilter: ['class', 'style', 'hidden', 'aria-hidden']
      });
    }
  }
})();

(() => {
  const t26Popup = document.querySelector('[data-t26-cart-message-popup]');

  if (!t26Popup) {
    return;
  }

  const t26Panel = t26Popup.querySelector('.t26-cart-message-popup__panel');
  const t26ImageLink = t26Popup.querySelector('[data-t26-cart-message-popup-image-link]');
  const t26TitleLink = t26Popup.querySelector('[data-t26-cart-message-popup-title-link]');
  const t26Options = t26Popup.querySelector('[data-t26-cart-message-popup-options]');
  const t26Quantity = t26Popup.querySelector('[data-t26-cart-message-popup-quantity]');
  const t26Price = t26Popup.querySelector('[data-t26-cart-message-popup-price]');
  const t26LineTotal = t26Popup.querySelector('[data-t26-cart-message-popup-line-total]');
  const t26ComparePrice = t26Popup.querySelector('[data-t26-cart-message-popup-compare-price]');
  const t26Discounts = t26Popup.querySelector('[data-t26-cart-message-popup-discounts]');
  const t26Cutting = t26Popup.querySelector('[data-t26-cart-message-popup-cutting]');
  const t26Subtotal = t26Popup.querySelector('[data-t26-cart-message-popup-subtotal]');
  const t26Count = t26Popup.querySelector('[data-t26-cart-message-popup-count]');
  const t26Shipping = t26Popup.querySelector('[data-t26-cart-message-popup-shipping]');
  const t26ShippingMessage = t26Popup.querySelector('[data-t26-cart-message-popup-shipping-message]');
  const t26ShippingProgress = t26Popup.querySelector('[data-t26-cart-message-popup-shipping-progress]');
  const t26CloseButton = t26Popup.querySelector('[data-t26-cart-message-popup-close]:not(.t26-cart-message-popup__backdrop)');

  const t26FormatWithDelimiters = (number, precision = 2, thousands = ',', decimal = '.') => {
    if (Number.isNaN(number) || number == null) {
      return '0';
    }

    const fixedNumber = (number / 100).toFixed(precision);
    const parts = fixedNumber.split('.');
    const dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, `$1${thousands}`);
    const cents = parts[1] ? decimal + parts[1] : '';

    return dollars + cents;
  };

  const t26FormatMoney = (cents) => {
    const amount = typeof cents === 'string' ? cents.replace('.', '') : cents;
    const format = window.theme && window.theme.currencyCodeEnabled
      ? window.theme.moneyWithCurrencyFormat
      : window.theme && window.theme.moneyFormat;
    const moneyFormat = format || '${{amount}}';
    const placeholder = moneyFormat.match(/\{\{\s*(\w+)\s*\}\}/);

    if (!placeholder) {
      return moneyFormat;
    }

    let value;

    switch (placeholder[1]) {
      case 'amount':
        value = t26FormatWithDelimiters(amount, 2);
        break;
      case 'amount_no_decimals':
        value = t26FormatWithDelimiters(amount, 0);
        break;
      case 'amount_with_comma_separator':
        value = t26FormatWithDelimiters(amount, 2, '.', ',');
        break;
      case 'amount_no_decimals_with_comma_separator':
        value = t26FormatWithDelimiters(amount, 0, '.', ',');
        break;
      case 'amount_with_apostrophe_separator':
        value = t26FormatWithDelimiters(amount, 2, "'", '.');
        break;
      default:
        value = t26FormatWithDelimiters(amount, 2);
    }

    return moneyFormat.replace(placeholder[0], value);
  };

  const t26GetVariantIdFromEvent = (event) => {
    if (event.detail && event.detail.variant && event.detail.variant.id) {
      return event.detail.variant.id;
    }

    const button = event.detail && event.detail.button;
    const form = button && button.closest && button.closest('form[action*="/cart/add"]');
    const variantInput = form && form.querySelector('[name="id"]');

    return variantInput ? variantInput.value : null;
  };

  const t26FindAddedItem = (cart, variantId, cuttingGroup) => {
    if (!cart || !Array.isArray(cart.items) || cart.items.length === 0) {
      return null;
    }

    if (!variantId) {
      return cart.items[0];
    }

    return cart.items.find((item) => String(item.variant_id) === String(variantId)
      && (!cuttingGroup || (item.properties && item.properties._t26_cutting_group === cuttingGroup))) || cart.items[0];
  };

  const t26SetImage = (lineItem) => {
    const imageUrl = lineItem && (lineItem.image || (lineItem.featured_image && lineItem.featured_image.url));
    const title = lineItem && (lineItem.product_title || lineItem.title || '');

    t26ImageLink.innerHTML = '';

    if (!imageUrl) {
      const placeholder = document.createElement('span');
      placeholder.className = 't26-cart-message-popup__image-placeholder';
      t26ImageLink.appendChild(placeholder);
      return;
    }

    const image = new Image();
    image.src = imageUrl;
    image.alt = title;
    image.loading = 'lazy';
    t26ImageLink.appendChild(image);
  };

  const t26SetOptions = (lineItem) => {
    const optionValues = lineItem && Array.isArray(lineItem.options_with_values)
      ? lineItem.options_with_values.filter((option) => option.value && option.value !== 'Default Title')
      : [];

    t26Options.innerHTML = '';

    optionValues.forEach((option) => {
      const optionElement = document.createElement('span');
      optionElement.textContent = `${option.name}: ${option.value}`;
      t26Options.appendChild(optionElement);
    });
  };

  const t26SetDiscounts = (lineItem) => {
    const discounts = lineItem && Array.isArray(lineItem.line_level_discount_allocations)
      ? lineItem.line_level_discount_allocations
      : [];

    t26Discounts.innerHTML = '';
    t26Discounts.hidden = discounts.length === 0;

    discounts.forEach((discount) => {
      const item = document.createElement('li');
      item.className = 'mini-cart__discount';
      const title = discount.discount_application && discount.discount_application.title
        ? discount.discount_application.title
        : discount.title || '';

      item.textContent = `${title} (-${t26FormatMoney(discount.amount)})`;
      t26Discounts.appendChild(item);
    });
  };

  const t26SetShipping = (cart) => {
    const isEnabled = t26Popup.dataset.t26FreeShippingEnabled === 'true';
    const threshold = Number(t26Popup.dataset.t26FreeShippingThreshold || 0);

    if (!isEnabled || !threshold || !t26Shipping || !t26ShippingMessage || !t26ShippingProgress) {
      if (t26Shipping) {
        t26Shipping.hidden = true;
      }

      return;
    }

    const total = cart && Number(cart.total_price) ? Number(cart.total_price) : 0;
    const remaining = Math.max(threshold - total, 0);
    const progress = Math.min(total / threshold * 100, 100);

    t26Shipping.hidden = false;
    t26ShippingProgress.style.width = `${progress}%`;

    if (remaining === 0) {
      t26ShippingMessage.textContent = t26Popup.dataset.t26FreeShippingComplete || '';
    } else {
      const template = t26Popup.dataset.t26FreeShippingRemainingTemplate || '';
      t26ShippingMessage.innerHTML = template.replace('[amount]', t26FormatMoney(remaining));
    }
  };

  const t26UpdatePopup = (cart, lineItem, addedQuantity) => {
    const title = lineItem && (lineItem.product_title || lineItem.title || '');
    const url = lineItem && lineItem.url ? lineItem.url : window.routes.cartUrl;
    const quantity = Math.max(parseInt(addedQuantity, 10) || 1, 1);
    const finalPrice = lineItem && Number(lineItem.final_price) ? Number(lineItem.final_price) : 0;
    const originalPrice = lineItem && Number(lineItem.original_price) ? Number(lineItem.original_price) : finalPrice;

    t26SetImage(lineItem);
    t26SetOptions(lineItem);
    t26SetDiscounts(lineItem);

    t26ImageLink.href = url;
    t26TitleLink.href = url;
    t26TitleLink.textContent = title;
    t26Quantity.textContent = `${quantity} x`;
    t26Price.innerHTML = t26FormatMoney(finalPrice);
    t26LineTotal.innerHTML = `= ${t26FormatMoney(finalPrice * quantity)}`;

    if (t26Cutting) {
      const group = lineItem && lineItem.properties && lineItem.properties._t26_cutting_group;
      const service = group && window.t26CuttingService.findPair(cart.items, group).service;

      t26Cutting.hidden = !service;
      t26Cutting.textContent = service
        ? `${service.product_title || 'Fabric Cutting Service'} · ${service.variant_title || service.properties['Cutting width']} · ${t26FormatMoney(service.final_line_price)}`
        : '';
    }

    if (originalPrice > finalPrice) {
      t26ComparePrice.hidden = false;
      t26ComparePrice.innerHTML = t26FormatMoney(originalPrice * quantity);
    } else {
      t26ComparePrice.hidden = true;
      t26ComparePrice.innerHTML = '';
    }

    t26Subtotal.innerHTML = t26FormatMoney(cart.total_price);
    t26Count.textContent = cart.item_count;
    window.theme.cartCount = cart.item_count;

    document.querySelectorAll('.header__cart-count').forEach((countElement) => {
      countElement.textContent = cart.item_count;
    });

    t26SetShipping(cart);
  };

  const t26OpenPopup = () => {
    t26Popup.classList.add('is-visible');
    t26Popup.setAttribute('aria-hidden', 'false');

    if (t26CloseButton) {
      t26CloseButton.focus({ preventScroll: true });
    } else if (t26Panel) {
      t26Panel.focus({ preventScroll: true });
    }
  };

  const t26ClosePopup = () => {
    t26Popup.classList.remove('is-visible');
    t26Popup.setAttribute('aria-hidden', 'true');
  };

  const t26HandleProductAdded = (event) => {
    if (!window.theme || window.theme.cartType !== 'message' || !event.detail || !event.detail.productAdded) {
      return;
    }

    const variantId = t26GetVariantIdFromEvent(event);
    const quantity = event.detail.displayQuantity ?? event.detail.quantity;

    fetch(`${window.routes.cartUrl}.js`, {
      credentials: 'same-origin',
      headers: {
        'Cache-Control': 'no-cache'
      }
    }).then((response) => response.json()).then((cart) => {
      const lineItem = t26FindAddedItem(cart, variantId, event.detail.cuttingGroup);

      if (!lineItem) {
        return;
      }

      t26UpdatePopup(cart, lineItem, quantity);
      t26OpenPopup();
    }).catch(() => {});
  };

  document.addEventListener('product:added', t26HandleProductAdded);
  t26Popup.addEventListener('click', (event) => {
    if (event.target.closest('[data-t26-cart-message-popup-close]')) {
      t26ClosePopup();
    }
  });
  document.addEventListener('keydown', (event) => {
    if (event.key === 'Escape' && t26Popup.classList.contains('is-visible')) {
      t26ClosePopup();
    }
  });
})();

(() => {
  const t26SwatchOrderSelector = '[data-t26-swatch-order]';
  const t26AddSwatchSelector = '[data-action="t26-add-swatch"]';
  let t26SyncTimeout;

  const t26SetButtonState = (button, state) => {
    if (!button) {
      return;
    }

    const states = {
      add: button.querySelector('.t26-swatch-order__button-text'),
      checking: button.querySelector('.t26-swatch-order__button-checking'),
      adding: button.querySelector('.t26-swatch-order__button-loading'),
      added: button.querySelector('.t26-swatch-order__button-added')
    };

    Object.keys(states).forEach((key) => {
      if (states[key]) {
        states[key].hidden = key !== state;
      }
    });

    button.classList.toggle('is-checking', state === 'checking');
    button.classList.toggle('is-loading', state === 'adding');
    button.classList.toggle('is-added', state === 'added');

    if (state === 'add') {
      button.removeAttribute('disabled');
    } else {
      button.setAttribute('disabled', 'disabled');
    }
  };

  const t26ProcessSwatchCartState = (component, cart) => {
    const button = component && component.querySelector(t26AddSwatchSelector);
    const variantId = Number(component && component.dataset.swatchVariantId);
    const productId = Number(component && component.dataset.productId);

    if (!button || !variantId || !cart || !Array.isArray(cart.items)) {
      if (button) {
        t26SetButtonState(button, 'add');
      }

      return;
    }

    const isInCart = cart.items.some((item) => Number(item.variant_id) === variantId && Number(item.product_id) === productId);

    t26SetButtonState(button, isInCart ? 'added' : 'add');
  };

  const t26SyncSwatchOrders = (showChecking = false) => {
    const components = Array.from(document.querySelectorAll(t26SwatchOrderSelector));

    if (components.length === 0 || !window.routes || !window.routes.cartUrl) {
      return;
    }

    if (showChecking) {
      components.forEach((component) => {
        const button = component.querySelector(t26AddSwatchSelector);

        if (button && !button.classList.contains('is-loading') && !button.classList.contains('is-added')) {
          t26SetButtonState(button, 'checking');
        }
      });
    }

    fetch(`${window.routes.cartUrl}.js`, {
      credentials: 'same-origin',
      headers: {
        'Cache-Control': 'no-cache',
        'X-Requested-With': 'XMLHttpRequest'
      }
    }).then((response) => {
      if (!response.ok) {
        throw new Error('Cart fetch failed');
      }

      return response.json();
    }).then((cart) => {
      components.forEach((component) => t26ProcessSwatchCartState(component, cart));
    }).catch(() => {
      components.forEach((component) => {
        const button = component.querySelector(t26AddSwatchSelector);

        if (button && !button.classList.contains('is-added')) {
          t26SetButtonState(button, 'add');
        }
      });
    });
  };

  const t26DebounceSyncSwatchOrders = () => {
    window.clearTimeout(t26SyncTimeout);
    t26SyncTimeout = window.setTimeout(t26SyncSwatchOrders, 300);
  };

  const t26ShowSwatchError = (component, message) => {
    const productForm = component.closest('.product-form') || component;
    const existingMessage = productForm.querySelector('.cart__status-message--product');

    if (existingMessage) {
      existingMessage.remove();
    }

    const messageElement = document.createElement('div');
    messageElement.className = 'cart__status-message cart__status-message--product';

    const alertElement = document.createElement('div');
    alertElement.className = 'alert alert--error';

    const textElement = document.createElement('p');
    textElement.textContent = message || 'Error adding swatch to cart';

    alertElement.appendChild(textElement);
    messageElement.appendChild(alertElement);
    productForm.appendChild(messageElement);

    window.setTimeout(() => messageElement.remove(), 5500);
  };

  const t26AddSwatchToCart = (event) => {
    const button = event.target.closest && event.target.closest(t26AddSwatchSelector);

    if (!button) {
      return;
    }

    event.preventDefault();
    event.stopPropagation();

    if (button.disabled || button.classList.contains('is-loading') || button.classList.contains('is-added')) {
      return;
    }

    const component = button.closest(t26SwatchOrderSelector);
    const variantId = Number(button.dataset.variantId);

    if (!component || !variantId || !window.routes || !window.routes.cartAddUrl) {
      return;
    }

    t26SetButtonState(button, 'adding');
    document.dispatchEvent(new CustomEvent('theme:loading:start'));

    fetch(`${window.routes.cartAddUrl}.js`, {
      body: JSON.stringify({
        id: variantId,
        quantity: 1
      }),
      credentials: 'same-origin',
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'X-Requested-With': 'XMLHttpRequest'
      }
    }).then((response) => {
      document.documentElement.dispatchEvent(new CustomEvent('product:added', {
        bubbles: true,
        detail: {
          button,
          variant: { id: variantId },
          quantity: 1,
          productAdded: response.ok
        }
      }));

      if (response.ok) {
        if (window.theme && (window.theme.pageType === 'cart' || window.theme.cartType === 'page')) {
          window.location.href = window.routes.cartUrl;
          return null;
        }

        if (window.theme && window.theme.cartType === 'drawer') {
          document.dispatchEvent(new CustomEvent('modal:close'));
        }

        t26SetButtonState(button, 'added');
        document.dispatchEvent(new CustomEvent('theme:loading:end'));
        t26DebounceSyncSwatchOrders();
        return null;
      }

      return response.json().then((content) => {
        t26SetButtonState(button, 'add');
        t26ShowSwatchError(component, content.description);
        document.dispatchEvent(new CustomEvent('theme:loading:end'));
      });
    }).catch(() => {
      t26SetButtonState(button, 'add');
      t26ShowSwatchError(component);
      document.dispatchEvent(new CustomEvent('theme:loading:end'));
    });
  };

  document.addEventListener('click', t26AddSwatchToCart);
  document.addEventListener('cart:rerendered', t26DebounceSyncSwatchOrders);
  document.addEventListener('product:added', t26DebounceSyncSwatchOrders);

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => t26SyncSwatchOrders(true));
  } else {
    t26SyncSwatchOrders(true);
  }

  if (typeof MutationObserver !== 'undefined') {
    const observer = new MutationObserver((mutations) => {
      const needsSync = mutations.some((mutation) => Array.from(mutation.addedNodes).some((node) => {
        return node.nodeType === 1 && (
          (node.matches && node.matches(t26SwatchOrderSelector)) ||
          (node.querySelector && node.querySelector(t26SwatchOrderSelector))
        );
      }));

      if (needsSync) {
        t26DebounceSyncSwatchOrders();
      }
    });

    observer.observe(document.body, {
      childList: true,
      subtree: true
    });
  }
})();

(() => {
  const t26LoadingButtonSelector = '[data-t26-loading-button]';
  const t26CheckoutButtonSelector = '[data-t26-loading-button="checkout"]';
  const t26AddToCartButtonSelector = '[data-t26-loading-button="add-to-cart"]';
  const t26LoadingClass = 'is-loading';

  const t26SetButtonLoading = (button, isLoading) => {
    if (!button) {
      return;
    }

    button.classList.toggle(t26LoadingClass, isLoading);
    button.setAttribute('aria-busy', isLoading ? 'true' : 'false');
  };

  const t26ClearProductLoadingButtons = () => {
    document.querySelectorAll(`${t26AddToCartButtonSelector}.${t26LoadingClass}`).forEach((button) => {
      t26SetButtonLoading(button, false);
    });
  };

  const t26ClearCheckoutLoadingButtons = () => {
    document.querySelectorAll(`${t26CheckoutButtonSelector}.${t26LoadingClass}`).forEach((button) => {
      t26SetButtonLoading(button, false);
    });
  };

  document.addEventListener('click', (event) => {
    const button = event.target.closest && event.target.closest(t26LoadingButtonSelector);

    if (!button || button.disabled || button.classList.contains('button--disabled')) {
      return;
    }

    if (button.matches(t26AddToCartButtonSelector)) {
      t26SetButtonLoading(button, true);
      return;
    }

    if (button.matches(t26CheckoutButtonSelector)) {
      t26SetButtonLoading(button, true);

      window.setTimeout(() => {
        if (button.isConnected) {
          t26SetButtonLoading(button, false);
        }
      }, 15000);
    }
  }, true);

  document.addEventListener('product:added', t26ClearProductLoadingButtons);
  document.addEventListener('theme:loading:end', t26ClearProductLoadingButtons);
  window.addEventListener('pageshow', () => {
    t26ClearProductLoadingButtons();
    t26ClearCheckoutLoadingButtons();
  });
})();

(() => {
  const t26QuantityActionSelector = '[data-action="decrease-quantity"], [data-action="increase-quantity"]';
  const t26QuantityInputSelector = '.quantity-selector:not(.quantity-selector--product) .quantity-selector__value';
  const t26LoadingClass = 't26-is-loading';
  const t26LoadingOverlayClass = 't26-cart-line-item-loading';
  const t26LoadingTimeout = 10000;

  const t26GetLineItem = (target) => target && target.closest
    ? target.closest('.line-item, .mini-cart__line-item')
    : null;

  const t26RemoveLoadingState = (lineItem) => {
    if (!lineItem) {
      return;
    }

    lineItem.classList.remove(t26LoadingClass);
    delete lineItem.dataset.t26CartLoading;

    const overlay = lineItem.querySelector(`.${t26LoadingOverlayClass}`);

    if (overlay) {
      overlay.remove();
    }
  };

  const t26RemoveAllLoadingStates = () => {
    document.querySelectorAll(`.line-item.${t26LoadingClass}, .mini-cart__line-item.${t26LoadingClass}`).forEach(t26RemoveLoadingState);
  };

  const t26AddLoadingState = (target) => {
    const lineItem = t26GetLineItem(target);

    if (!lineItem || lineItem.classList.contains(t26LoadingClass)) {
      return lineItem;
    }

    lineItem.classList.add(t26LoadingClass);
    lineItem.dataset.t26CartLoading = 'true';

    if (!lineItem.querySelector(`.${t26LoadingOverlayClass}`)) {
      const overlay = document.createElement('div');
      overlay.className = t26LoadingOverlayClass;
      overlay.setAttribute('aria-hidden', 'true');

      const spinner = document.createElement('div');
      spinner.className = 't26-cart-line-item-loading__spinner';
      overlay.appendChild(spinner);
      lineItem.appendChild(overlay);
    }

    window.setTimeout(() => {
      if (lineItem.isConnected && lineItem.dataset.t26CartLoading === 'true') {
        t26RemoveLoadingState(lineItem);
      }
    }, t26LoadingTimeout);

    return lineItem;
  };

  const t26HandleQuantityClick = (event) => {
    const control = event.target.closest && event.target.closest(t26QuantityActionSelector);

    if (!control) {
      return;
    }

    const lineItem = t26GetLineItem(control);

    if (lineItem && lineItem.classList.contains(t26LoadingClass)) {
      event.preventDefault();
      event.stopImmediatePropagation();
      return;
    }

    t26AddLoadingState(control);
  };

  const t26HandleQuantityChange = (event) => {
    const input = event.target && event.target.matches && event.target.matches(t26QuantityInputSelector)
      ? event.target
      : null;

    if (!input) {
      return;
    }

    const lineItem = t26GetLineItem(input);

    if (lineItem && lineItem.classList.contains(t26LoadingClass)) {
      event.preventDefault();
      event.stopImmediatePropagation();
      return;
    }

    t26AddLoadingState(input);
  };

  document.addEventListener('click', t26HandleQuantityClick, true);
  document.addEventListener('change', t26HandleQuantityChange, true);
  document.addEventListener('cart:rerendered', () => window.setTimeout(t26RemoveAllLoadingStates, 100));
  document.addEventListener('theme:loading:end', () => window.setTimeout(t26RemoveAllLoadingStates, 100));
})();

(() => {
  let t26AiBriefingHasAnimated = false;

  const t26AiBriefingTargetSelector = '.t26-ai-briefing-target';
  const t26AiBriefingToggleSelector = '.t26-ai-toggle-button';

  const t26TypeNode = (node, targetNode) => {
    if (node.nodeType === Node.TEXT_NODE) {
      const text = node.nodeValue;
      const span = document.createElement('span');
      targetNode.appendChild(span);

      return new Promise((resolve) => {
        let index = 0;

        const typeChar = () => {
          if (!targetNode.isConnected) {
            resolve();
            return;
          }

          if (index < text.length) {
            span.textContent += text.charAt(index);
            index += 1;
            window.setTimeout(typeChar, 5);
          } else {
            resolve();
          }
        };

        typeChar();
      });
    }

    if (node.nodeType === Node.ELEMENT_NODE) {
      const clone = node.cloneNode(false);
      targetNode.appendChild(clone);

      return Array.from(node.childNodes).reduce((promise, child) => {
        return promise.then(() => t26TypeNode(child, clone));
      }, Promise.resolve());
    }

    targetNode.appendChild(node.cloneNode(true));
    return Promise.resolve();
  };

  const t26TypeWriterEffect = (target) => {
    if (!target || target.dataset.t26Typed === 'true') {
      return;
    }

    const contentWrapper = target.querySelector('.t26-ai-content-wrapper');

    if (!contentWrapper) {
      return;
    }

    target.dataset.t26Typed = 'true';

    if (t26AiBriefingHasAnimated) {
      contentWrapper.classList.remove('is-hidden');
      return;
    }

    const originalNodes = Array.from(contentWrapper.childNodes);
    contentWrapper.classList.add('is-hidden');
    contentWrapper.innerHTML = '';
    contentWrapper.classList.remove('is-hidden');

    originalNodes.reduce((promise, child) => {
      return promise.then(() => t26TypeNode(child, contentWrapper));
    }, Promise.resolve()).catch(() => {
      contentWrapper.innerHTML = '';
      originalNodes.forEach((node) => contentWrapper.appendChild(node.cloneNode(true)));
      contentWrapper.classList.remove('is-hidden');
    });
  };

  const t26ToggleAiBriefing = (event) => {
    const button = event.target.closest && event.target.closest(t26AiBriefingToggleSelector);

    if (!button) {
      return;
    }

    const target = button.previousElementSibling;

    if (!target || !target.classList.contains('t26-ai-briefing-target')) {
      return;
    }

    const isExpanded = target.getAttribute('aria-expanded') === 'true';
    const nextExpanded = !isExpanded;

    target.setAttribute('aria-expanded', nextExpanded ? 'true' : 'false');
    button.setAttribute('aria-expanded', nextExpanded ? 'true' : 'false');
    button.textContent = nextExpanded ? '- View less' : '+ View more';
  };

  const t26InitAiBriefing = () => {
    document.querySelectorAll(t26AiBriefingTargetSelector).forEach(t26TypeWriterEffect);
    t26AiBriefingHasAnimated = true;
  };

  document.addEventListener('click', t26ToggleAiBriefing);

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', t26InitAiBriefing);
  } else {
    t26InitAiBriefing();
  }

  document.addEventListener('product:rerendered', t26InitAiBriefing);

  if (typeof MutationObserver !== 'undefined') {
    const observer = new MutationObserver((mutations) => {
      const shouldScan = mutations.some((mutation) => {
        return Array.from(mutation.addedNodes).some((node) => {
          return node.nodeType === Node.ELEMENT_NODE && (
            (node.matches && node.matches(t26AiBriefingTargetSelector)) ||
            (node.querySelector && node.querySelector(t26AiBriefingTargetSelector))
          );
        });
      });

      if (shouldScan) {
        t26InitAiBriefing();
      }
    });

    observer.observe(document.body, {
      childList: true,
      subtree: true
    });
  }
})();
